<mat-card class="dimension-card" [ngClass]="{'disabled-card':disable}">
  @if (device!.photoUrl) {
    <div class="principal-image-container">
      <div style="position: absolute;width: 100%;height: 100%">
        <div class="principal-image-container gradient">
          <h2
          class="color-text-white titleCard">{{device?.name}}</h2>
        </div>
      </div>
      <img src="{{device?.photoUrl}}" class="principal-image">
    </div>
  } @else {
    <div style="position: absolute;width: 100%;height: 100%">
      <div class="principal-image-container gradient">
        <h2
        class="color-text-white titleCard">{{device?.name}}</h2>
      </div>
    </div>
    <div style="display: flex;align-items: center;justify-content: center;height:calc(100% - 50px);width: 100%">
      <div (click)="addPhoto($event)"
        style="z-index:1000;width: 75px;height: 75px;padding:15px "
        class="circle background-color-accent">
        <mat-icon class="icon-size-large" style="color: white">add_a_photo</mat-icon>
      </div>
    </div>
  }
  <div style="position: absolute;bottom: 13px;width: 100%">
    @if (differenceHourWithNow>2) {
      <button mat-mini-fab
        class="positon-bottom-left"
        (click)="$event.stopPropagation();"
        [disableRipple]="true">
        <mat-icon>warning</mat-icon>
      </button>
    }
    <ng-content select="[upCard]">

    </ng-content>
    <div style="display: flex;align-items: center;justify-content: center;">
      <mat-card
        style="min-width: 50%;padding: 5px;color: white;width: 76%"
                    [ngClass]="{ 'background-color-yellow':getActivedClass(sensorDataType==='POWER_CONSUMPTION'),
                                 'background-color-purple':getActivedClass(sensorDataType==='POWER_PRODUCTION'),
                                 'background-color-accent':getActivedClass(sensorDataType==='TEMPERATURE'),
                                 'background-color-verdeBlue':getActivedClass(sensorDataType==='BATTERY_OUTPUT'),
                                 'background-color-rosso':getActivedClass(sensorDataType==='BATTERY_INPUT'),
                                 'background-color-cyan':getActivedClass(sensorDataType==='NETWORK_ENERGY_SOLD'),
                                 'background-color-orange':getActivedClass(sensorDataType==='NETWORK_ENERGY_BOUGHT'),
                                 'selcted-card':selected}">

        <span style="font-weight: bold">{{getKeyTrad(sensorDataType) |translate}}</span>
        <h2>{{sensorDataValue|unitOfMeasurement:sensorDataType:2}}</h2>
      </mat-card>
    </div>
  </div>
  <div class="container-dx">
    <div class="child-dx">
      @if (sensorDataTypeIsTemperature) {
        <button (click)="$event.stopPropagation();clickTemperature()" mat-mini-fab
          >
          <mat-icon svgIcon="termomether"></mat-icon>
        </button>
      }
    </div>
  </div>
  <!--    <div class="container-bottom">-->
  <!--        <div class="child-bottom">-->
  <!--            <button mat-mini-fab-->
  <!--                    (click)="$event.stopPropagation();"-->
  <!--                    *ngIf="differenceHourWithNow>2" [disableRipple]="true">-->
  <!--                <mat-icon>warning</mat-icon>-->
<!--            </button>-->
<!--            <div class="spacerh5"></div>-->
<!--            <button (click)="$event.stopPropagation();clickTemperature()" mat-mini-fab-->
<!--                    *ngIf="sensorDataTypeIsTemperature">-->
<!--                <mat-icon svgIcon="termomether"></mat-icon>-->
<!--            </button>-->
<!--        </div>-->
<!--    </div>-->
</mat-card>



